module.exports = __webpack_public_path__ + "media/country_flags/tj-24a742ec.png";